import gsap from 'gsap'

class Cursor {
  bindMethods() {
    this.onMouseMove = this.onMouseMove.bind(this)
    this.resetScale = this.resetScale.bind(this)
  }

  constructor() {
    this.bindMethods()
    this.prepapreCursorParams()
    this.events()
  }

  prepapreCursorParams() {
    this.cursor = document.querySelector('.cursor')
    this.cursorSize = this.cursor.offsetWidth
    this.currentMousePosition = {
      x: 0,
      y: 0
    }

    this.cursorParams = {
      x: 0,
      y: 0,
      scale: 1,
      opacity: 1,
      duration: 0.5
    }
  }

  events() {
    document.documentElement.addEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove(e) {
    this.moveTo(e.clientX, e.clientY)
  }

  moveTo(x, y) {
    gsap.to(this.cursor, {
      x,
      y,
      duration: 0.8,
      ease: 'power3.out'
    })
  }

  resetScale() {
    this.scaleTo(this.cursorSize)
    this.cursor.classList.remove('show-arrow')
  }

  setDragMode() {
    this.cursor.classList.add('show-drag')
  }

  resetDragMode() {
    this.cursor.classList.remove('show-drag')
  }

  removeBorders() {
    this.cursor.classList.add('no-border')
  }

  resetBorders() {
    this.cursor.classList.remove('no-border')
  }

  resetBackground() {
    this.cursor.classList.remove('no-background')
  }

  disableBackground() {
    this.cursor.classList.add('no-background')
  }

  checkLinks(view) {
    if (this.links) {
      this.removeEvents()
      this.links = []
    }

    this.links = view.querySelectorAll('[data-cursor-size]')

    this.addEvents()
  }

  scaleTo(value) {
    this.cursor.classList.add('show-arrow')
    gsap.to(this.cursor, {
      width: value,
      height: value,
      duration: 0.8,
      ease: 'power3.out'
    })
  }

  addEvents() {
    for (let i = 0; i < this.links.length; i++) {
      if (this.links[i].classList.contains('soldout') === false) {
        this.links[i].addEventListener('mouseenter', this.onMouseEnter.bind(this, i))
        this.links[i].addEventListener('mouseleave', this.resetScale)
      }
    }
  }

  removeEvents() {
    for (let i = 0; i < this.links.length; i++) {
      this.links[i].removeEventListener('mouseenter', this.onMouseEnter.bind(this, i))
      this.links[i].removeEventListener('mouseleave', this.resetScale)
    }
  }

  onMouseEnter(i) {
    this.scaleTo(this.links[i].dataset.cursorSize)
  }
}
export default Cursor



// WEBPACK FOOTER //
// ./scripts/util/Cursor.js